import { Component, OnInit } from '@angular/core';
import { UsersService, LoginModel, UserModel } from 'src/app/Api_Module';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  templateUrl: './user-login.component.html',
})
export class UserLoginComponent implements OnInit {
  constructor(private usersService: UsersService, private route: ActivatedRoute, private router: Router,
     private authSrvc: AuthenticationService, private toastr: ToastrService) { }

  loginReq: LoginModel;
  loading: boolean;
  returnUrl: string;

  ngOnInit() {
    this.loginReq = {};
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
    if (this.authSrvc.isLoggegIn()) {
      this.router.navigate([this.returnUrl]);
    }
  }

  login() {
    this.loading = true;
    this.usersService.authenticate(this.loginReq).subscribe((resp) => {
      this.loading = false;
      const user: UserModel = resp;
      localStorage.setItem('currentUser', JSON.stringify(user));
      this.router.navigate([this.returnUrl]);
    },
      error => {
        this.toastr.error('Login Failed!');
        this.loading = false;
      });
  }
}
